import React, { useState } from "react";
import { X, KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { changePassword, formatApiError } from "@/auth";
import { Field, ErrorBox, PrimaryButton } from "@/components/AuthShell";

export default function ChangePasswordModal({ open, forced, onClose, onChanged }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (!open) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) return setError("Passwords do not match.");
    setBusy(true); setError("");
    try {
      await changePassword(current, next);
      toast.success("Password updated");
      onChanged && onChanged();
      onClose && onClose();
    } catch (err) { setError(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="change-password-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={forced ? undefined : onClose} />
      <div className="relative z-10 w-full max-w-md rounded-2xl border border-slate-700 bg-[#161f32] p-6 shadow-2xl fade-up">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="flex items-center gap-2 font-display text-xl font-semibold text-slate-100">
            <KeyRound className="h-5 w-5 text-orange-400" /> {forced ? "Set a new password" : "Change password"}
          </h2>
          {!forced && (
            <button data-testid="change-password-close" onClick={onClose} className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-800"><X className="h-5 w-5" /></button>
          )}
        </div>
        {forced && <p className="mb-4 text-sm text-amber-300">Your administrator issued a temporary password. Choose your own password to continue.</p>}
        <form onSubmit={submit} className="space-y-3">
          {!forced && <Field label="Current password" testId="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required />}
          <Field label="New password (8+ characters, letter and number)" testId="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} required />
          <Field label="Confirm new password" testId="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          <ErrorBox error={error} testId="cp-error" />
          <PrimaryButton testId="cp-submit" type="submit" disabled={busy}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save password</PrimaryButton>
        </form>
      </div>
    </div>
  );
}
